import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/ikeda/src/shogi-player/web_component/node_modules/.pnpm/css-loader@6.8.1_webpack@5.86.0/node_modules/css-loader/dist/runtime/api.js'
import '/Users/ikeda/src/shogi-player/web_component/node_modules/.pnpm/vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/ikeda/src/shogi-player/web_component/node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_webpack@5.86.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js'

import shogiPlayerWc from '~root/src/components/ShogiPlayerWc.vue?shadow'
window.customElements.define('shogi-player-wc', wrap(Vue, shogiPlayerWc))